<template>
  <CCard class="question__card">
    <CCardHeader class="d-flex justify-content-between align-items-center">
      سوال
      <CButton
          :loading="loading"
          class="px-sm-5"
          color="primary"
          @click="onReturn"
      >
        بازگشت
      </CButton>
    </CCardHeader>
    <CCardBody class="d-flex align-items-start h-100">
      <CForm class="w-100">
        <CTextarea v-model="form.text" class="text-sm" label="صورت سوال"/>
        <div class="text-sm">افزودن فایل سوال</div>
        <UploadExamFile
            v-model="form.files"
            cat="EQ"
            @upload-file="onUploadExamFile"
        />
        <CInput
            v-if="question.type === 'TEXT'"
            v-model="form.mark"
            class="text-sm"
            label="بارم سوال"
            type="number"
        />
        <div
            v-if="question.type === 'MULTI_CHOICES'"
            class="d-flex flex-column justify-content-center"
        >
          <div class="mt-3"> گزینه ها:</div>
          <div :key="iterator">
            <div
                v-for="index in 6"
                :key="index"
                class="mt-3 d-flex align-items-center"
            >
              <CInputRadio
                  :checked="form.correctAnswerIndex === index - 1"
                  :disabled="choices[index - 1] === ''"
                  name="choices"
                  @update:checked="form.correctAnswerIndex = index - 1"
              >
                <template #label>
                  {{ index }}.
                  <UploadSingleImage
                      v-if="choices[0].includes('http')"
                      :key="choices[index - 1]"
                      v-model="choices"
                      :disabled="choices[index - 2] === ''"
                      :index="index"
                      cat="EMCH"
                      class="text-sm  mr-2 mb-0"
                      @upload-image="onUploadSingleImageImageUrl"
                  />
                  <CInput
                      v-else
                      v-model="choices[index - 1]"
                      :disabled="choices[index - 2] === ''"
                      class="text-sm flex-fill mr-2 mb-0"
                      placeholder="عنوان گزینه"
                  />
                </template>
              </CInputRadio>
            </div>
          </div>
        </div>
        <div
            v-if="question.type === 'MULTI_CHOICES'"
            class="mt-3 d-flex align-items-center text-sm"
        >
          <CSwitch
              :checked="form.randomizeChoice"
              :value="form.randomizeChoice"
              class="ml-3"
              color="primary"
              variant="3d"
              @update:checked="onRandomizeChoice"
          />
          نمایش ترتیب گزینه‌ها به صورت تصادفی
        </div>
      </CForm>
    </CCardBody>
    <CCardFooter class="d-flex justify-content-between align-items-center">
      <CButton
          :loading="loading"
          class="px-5"
          color="primary"
          @click="onEditQuestion"
      >
        ثبت
      </CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
import axios from "@/plugins/axios";
import UploadExamFile from "../UploadExamFile/UploadExamFile.vue";
import UploadSingleImage from "../UploadSingleImage/UploadSingleImage";

export default {
  components: {UploadSingleImage, UploadExamFile},
  props: {
    value: {
      type: Boolean,
    },
    question: {
      type: Object,
    },
  },
  data() {
    return {
      form: {
        text: "",
        choices: this.choices,
        randomizeChoice: false,
        files: "",
      },
      loading: false,
      choices: ["", "", "", "", "", ""],
      iterator: 0,
    };
  },

  computed: {
    editQuestionCard: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    choices() {
      try {
        let flag = false;

        for (let i = 0; i < (6 - this.choices.length); i++) {
          this.choices.push('')
        }
        for (let index = 0; index < 6; index++) {
          if (this.choices[index] === "") flag = true;
          else if (flag) this.choices[index] = "";
        }
      } catch (error) {
        console.log("errrrrror", error);
      }
    },
  },
  mounted() {
    if (this.question.type === 'MULTI_CHOICES') this.choices = [...this.question.choices];
    this.form = {
      text: this.question.text,
      files: this.question.fileUrl,
      choices: this.choices,
      correctAnswerIndex: this.question.correctAnswerIndex,
      randomizeChoice: this.question.randomizeChoice,
      mark: this.question.mark,
      type: this.question.type,
    };
  },
  methods: {
    async onEditQuestion() {
      try {
        this.loading = true;
        const {id: examId} = this.$route.params;
        const payload = {
          text: this.form.text,
          fileUrl: this.form.files,
          choices: this.choices,
          correctAnswerIndex: this.form.correctAnswerIndex,
          randomizeChoice: this.form.randomizeChoice,
          mark: this.form.mark,
          type: this.question.type,
        };
        await axios
            .put(`/exam/${examId}/question/${this.question.id}`, payload)
            .then((response) => {
              if (response.data.status) this.editQuestionCard = false;
              this.$emit("get-questions");
            });
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    onUploadExamFile(file) {
      this.form.files = file;
    },
    onRandomizeChoice() {
      this.form.randomizeChoice = !this.form.randomizeChoice;
    },
    onReturn() {
      this.editQuestionCard = false;
    },
    onUploadSingleImageImageUrl(image, index) {
      this.choices[index - 1] = image;
      this.iterator += 1
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .vpd-container {
    .vpd-content {
      border-radius: 8px;

      .vpd-header {
        border-radius: 8px 8px 0 0;
      }
    }
  }

  .form-check {
    display: flex;
    align-items: center;
    width: 100%;

    .form-check-input {
      width: 24px;
      height: 24px;
      position: static;
      margin-top: 0;
      margin-left: 8px;
    }
  }
}

.checkboxes {
  column-count: 2;
  column-gap: 10px;
}
</style>